export default __webpack_public_path__ + "static/media/tel_ico.85a4c8e5.svg";